import React from 'react';

import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import BlockIcon from '@mui/icons-material/Block';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import RestoreFromTrashRoundedIcon from '@mui/icons-material/RestoreFromTrashRounded';

import classes from './StatusCell.module.scss';
import { Status } from '../../../../../shared/components/ui-components';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../shared/constants/apiDateFormat';
import { EntityStatus } from '../../../../constants/entityStatus';

export type StatusCellProps = {
  status: EntityStatus;
  subscriptionExpire: string | null;
};

const dataTestId = 'status-cell';

const StatusCell = ({ status, subscriptionExpire }: StatusCellProps) => {
  const subscriptionExpireDate = subscriptionExpire
    ? getFormattedDate(subscriptionExpire, localDataFormat)
    : null;

  switch (status) {
    case 'ACTIVE':
      return (
        <Status
          icon={<CheckCircleRoundedIcon fontSize="medium" color="success" />}
          dataTestId={dataTestId}
        >
          <div className={classes.statusCellWithDate}>
            <p>Active</p>
            {subscriptionExpireDate && <span>{subscriptionExpireDate}</span>}
          </div>
        </Status>
      );
    case 'INACTIVE':
      return (
        <Status
          icon={<CancelRoundedIcon fontSize="medium" color="error" />}
          dataTestId={dataTestId}
        >
          <div className={classes.statusCellWithDate}>
            <p>Inactive</p>
            {subscriptionExpireDate && <span>{subscriptionExpireDate}</span>}
          </div>
        </Status>
      );
    case 'INCOMPLETE':
      return (
        <Status
          icon={<BlockIcon fontSize="medium" color="error" />}
          dataTestId={dataTestId}
        >
          Incomplete
        </Status>
      );
    case 'PAYMENT_ISSUE':
      return (
        <Status
          icon={<WarningRoundedIcon fontSize="medium" color="warning" />}
          dataTestId={dataTestId}
        >
          Payment Issue
        </Status>
      );
    case 'DEACTIVATED':
      return (
        <Status
          icon={<RestoreFromTrashRoundedIcon fontSize="medium" color="tertiary" />}
          dataTestId={dataTestId}
        >
          Deactivated
        </Status>
      );
    default:
      return <div>No Info</div>;
  }
};

export { StatusCell };
